import {theme} from '@eCommerce/frontend-legacy-shared-library-native';
import {HEART_FAVORITE_ANIMATION} from 'assets/LottieAnimations';
import {Pressable} from 'native-base';
import React, {useState} from 'react';
import {Platform} from 'react-native';
import Icon from 'react-native-vector-icons/FontAwesome5Pro';

import LottieView from 'components/LottieView';
import {OfferCardSize} from 'hooks/useOfferCardTheme';
import {OfferPreferences} from 'models/Offer';

const HeartFavorite: React.FC<{
  onFavoritePress: () => void;
  pref: OfferPreferences;
  isLarge?: boolean;
  isOfferLoading: boolean;
  cardSize?: OfferCardSize;
}> = ({
  onFavoritePress,
  pref,
  isLarge = false,
  isOfferLoading,
  cardSize = OfferCardSize.LG,
}) => {
  const {
    fontSizes,
    colors: {paleSky},
  } = theme;
  const [shouldDisplayAnimation, setShouldDisplayAnimation] = useState(false);
  const isFavorite = pref === OfferPreferences.Favorite;

  const getStyle = () => {
    switch (cardSize) {
      case OfferCardSize.LG:
        return {
          height: '64px',
          width: '64px',
          marginTop: '-24px',
          marginRight: '-24px',
          marginBottom: '-12px',
        };
      case OfferCardSize.MD:
        return {
          height: '46px',
          width: '46px',
          marginTop: '-16px',
          marginRight: '-16px',
          marginBottom: '-10px',
        };
      default:
        return {
          height: '38px',
          width: '38px',
          marginTop: '-12px',
          marginRight: '-12px',
          marginBottom: '-10px',
        };
    }
  };

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={isFavorite ? 'Unfavorite Offer' : 'Favorite Offer'}
      testID="heart-favorite"
      alignItems="center"
      justifyContent="center"
      {...getStyle()}
      onPress={() => {
        if (isOfferLoading) {
          return;
        }
        setShouldDisplayAnimation(isFavorite ? false : true);
        onFavoritePress();
      }}>
      {shouldDisplayAnimation ? (
        <LottieView
          source={HEART_FAVORITE_ANIMATION}
          autoPlay
          onAnimationFinish={() => setShouldDisplayAnimation(false)}
          style={{height: '100%', width: '100%'}}
        />
      ) : (
        <Icon
          name="heart"
          size={isLarge ? fontSizes[7] : fontSizes[4]}
          color={isFavorite ? '#EFB21E' : paleSky}
          light={!isFavorite}
          solid={isFavorite}
          style={{marginLeft: Platform.OS === 'web' ? 1 : 0}}
        />
      )}
    </Pressable>
  );
};

export default HeartFavorite;
